import { render, staticRenderFns } from "./SourSmplList.vue?vue&type=template&id=6b1f952a&scoped=true&"
import script from "./SourSmplList.vue?vue&type=script&lang=js&"
export * from "./SourSmplList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f952a",
  null
  
)

export default component.exports